import axios from 'axios'
import type {
  TradingDataKlinesResponse,
  TradingDataMarketState,
  TradingDataTokenEntry,
  TradingDataTokensResponse,
} from '@/shared/types'

const tradingDataApiClient = axios.create({
  baseURL: import.meta.env.VITE_TRADING_DATA_API_URL || '/trading-data',
  timeout: 15_000,
  headers: {
    'Content-Type': 'application/json',
  },
})

export const tradingDataApi = {
  async getTokens(): Promise<TradingDataTokenEntry[]> {
    const { data } = await tradingDataApiClient.get<TradingDataTokensResponse>('/tokens')
    return data.tokens ?? []
  },

  async getKlines(tokenAddress: string, interval = '5m', limit = 240): Promise<TradingDataKlinesResponse> {
    const { data } = await tradingDataApiClient.get<TradingDataKlinesResponse>(
      `/tokens/${encodeURIComponent(tokenAddress)}/klines`,
      {
        params: {
          interval,
          limit,
          order: 'desc',
        },
      },
    )

    // Reverse so candles are in ascending chronological order for the chart
    if (data.klines) {
      data.klines.reverse()
    }

    return data
  },

  async getMarketState(tokenAddress: string): Promise<TradingDataMarketState> {
    const { data } = await tradingDataApiClient.get<TradingDataMarketState>(
      `/tokens/${encodeURIComponent(tokenAddress)}/market`,
    )

    return data
  },
}

export function getTradingDataWebSocketUrl(): string {
  const envUrl = import.meta.env.VITE_TRADING_DATA_WS_URL as string | undefined
  if (envUrl && envUrl.trim().length > 0) {
    return envUrl
  }

  if (typeof window === 'undefined') {
    return 'ws://localhost:3002/ws'
  }

  const wsProtocol = window.location.protocol === 'https:' ? 'wss' : 'ws'
  return `${wsProtocol}://${window.location.host}/trading-data/ws`
}
